import * as layoutConfigs from './configs';

export const layoutResolver = (publicationCode, edition) => {
  return layoutConfigs[publicationCode](edition);
};
export const shippingIndexResolver = (publicationCode) => {
  return layoutConfigs[publicationCode]('edition').shippingBlock;
};
